import React from "react";

export const NotesCell = ({ notes }: { notes?: string[] }) => {
  return (
    <div className="flex justify-center">
      <div
        className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium text-white ${
          notes && notes.length > 0 ? "bg-red-500" : "bg-gray-400"
        }`}
      >
        {notes && notes.length ? notes.length : "0"}
      </div>
    </div>
  );
};
